(ns renolit-roofing-service.service.service
  (:require
   [dev.gethop.session.re-frame.cognito.token :as cognito.token]
   [re-frame.core :as rf]
   [renolit-roofing-service.util :as util]))

(rf/reg-sub
 ::services
 (fn [db]
   (get db :services)))

(rf/reg-event-db
 ::clear-services
 (fn [db]
   (dissoc db :services)))

(rf/reg-event-db
 ::set-services
 (fn [db [_ services]]
   (assoc db :services services)))

(rf/reg-event-fx
 ::load-services-success
 (fn [_ [_ on-success-evt {:keys [services]}]]
   {:fx (cond-> [[:dispatch [::set-services services]]]
          on-success-evt
          (conj [:dispatch (conj on-success-evt services)]))}))

(defmulti fetch-services-event-fx
  (fn [_ [_ _ opts]]
    (:response-type opts :list)))

(defmethod fetch-services-event-fx :list
  [{:keys [session]}
   [_ _ {:keys [on-success-evt on-failure-evt extra-params]}]]
  (when session
    {:http-xhrio
     {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
      :method :get
      :uri "/api/services"
      :params (or extra-params {})
      :response-format (util/ajax-transit-response-format)
      :on-success [::load-services-success on-success-evt]
      :on-failure [::util/generic-error-with-callback on-failure-evt {}]}}))

(rf/reg-event-fx
 ::fetch-services
 [(rf/inject-cofx ::cognito.token/session)]
 fetch-services-event-fx)

(rf/reg-sub
 ::project-cache
 (fn [db]
   (get db :installer-project-cache)))

(rf/reg-event-db
 ::clear-project-cache
 (fn [db]
   (dissoc db :installer-project-cache)))

(rf/reg-event-db
 ::set-project
 (fn [db [_ project-id project]]
   (assoc-in db [:installer-project-cache project-id] project)))

(rf/reg-event-fx
 ::load-project-success
 (fn [_ [_ project-id on-success-evt {:keys [project]}]]
   {:fx (cond-> [[:dispatch [::set-project project-id project]]]
          on-success-evt
          (conj [:dispatch (conj on-success-evt project)]))}))

(defmulti fetch-project-event-fx
  (fn [_ [_ _ opts]]
    (:response-type opts :default)))

(defmethod fetch-project-event-fx :default
  [{:keys [session]}
   [_ project-id {:keys [on-success-evt on-failure-evt]}]]
  (when session
    {:http-xhrio
     {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
      :method :get
      :uri (str "/api/projects/" project-id)
      :params {}
      :response-format (util/ajax-transit-response-format)
      :on-success [::load-project-success project-id on-success-evt]
      :on-failure [::util/generic-error-with-callback on-failure-evt {}]}}))

(rf/reg-event-fx
 ::fetch-project
 [(rf/inject-cofx ::cognito.token/session)]
 fetch-project-event-fx)

(rf/reg-event-fx
 ::fetch-services-with-projects
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ {:keys [on-success-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :get
       :uri "/api/services"
       :params {}
       :response-format (util/ajax-transit-response-format)
       :on-success [::services-with-projects-loaded on-success-evt]
       :on-failure [::util/generic-error]}})))

(rf/reg-event-fx
 ::services-with-projects-loaded
 (fn [{:keys [db]} [_ on-success-evt {services :list}]]
   (let [project-ids (distinct (map :project-id services))]
     {:fx (concat
           [[:dispatch [::set-services services]]]
           (mapv (fn [project-id]
                   [:dispatch [::fetch-project project-id nil]])
                 project-ids)
           (when on-success-evt
             [[:dispatch (conj on-success-evt {:services services
                                               :projects project-ids})]]))})))

(rf/reg-sub
 ::current-service
 (fn [db]
   (get db :current-service)))

(rf/reg-event-db
 ::set-current-service
 (fn [db [_ service]]
   (assoc db :current-service service)))

(rf/reg-event-db
 ::clear-service
 (fn [db]
   (dissoc db :current-service)))

(rf/reg-event-fx
 ::load-service-success
 (fn [_ [_ on-success-evt {:keys [service]}]]
   (let [project-id (:project-id service)]
     {:fx (cond-> [[:dispatch [::set-current-service service]]]
            project-id
            (conj [:dispatch [::fetch-project project-id {:on-success-evt [::assoc-project-to-service]}]])
            on-success-evt
            (conj [:dispatch (conj on-success-evt service)]))})))

(rf/reg-event-db
 ::assoc-project-to-service
 (fn [db [_ project]]
   (update db :current-service assoc :project project)))

(rf/reg-event-fx
 ::fetch-service-by-id
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :get
       :uri (str "/api/services/" service-id)
       :params {}
       :response-format (util/ajax-transit-response-format)
       :on-success [::load-service-success on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-event-fx
 ::append-review-success
 (fn [_ [_ service-id on-success-evt _response]]
   {:fx (cond-> [[:dispatch [::fetch-service-by-id service-id]]]
          on-success-evt
          (conj [:dispatch on-success-evt]))}))

(rf/reg-event-fx
 ::append-service-review
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id review {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :put
       :uri (str "/api/services/" service-id "/reviews")
       :params review
       :format (util/ajax-transit-request-format)
       :response-format (util/ajax-transit-response-format)
       :on-success [::append-review-success service-id on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-event-fx
 ::append-observation-success
 (fn [_ [_ service-id on-success-evt _response]]
   {:fx (cond-> [[:dispatch [::fetch-service-by-id service-id]]]
          on-success-evt
          (conj [:dispatch on-success-evt]))}))

(rf/reg-event-fx
 ::append-service-observation
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id observation {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :put
       :uri (str "/api/services/" service-id "/observations")
       :params observation
       :format (util/ajax-transit-request-format)
       :response-format (util/ajax-transit-response-format)
       :on-success [::append-observation-success service-id on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-event-fx
 ::delete-observation-success
 (fn [_ [_ service-id on-success-evt _response]]
   {:fx (cond-> [[:dispatch [::fetch-service-by-id service-id]]]
          on-success-evt
          (conj [:dispatch on-success-evt]))}))

(rf/reg-event-fx
 ::delete-service-observation
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id observation-id {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :delete
       :uri (str "/api/services/" service-id "/observations/" observation-id)
       :format (util/ajax-transit-request-format)
       :response-format (util/ajax-transit-response-format)
       :on-success [::delete-observation-success service-id on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-event-fx
 ::update-service-success
 (fn [_ [_ service-id on-success-evt _response]]
   {:fx (cond-> [[:dispatch [::fetch-service-by-id service-id]]]
          on-success-evt
          (conj [:dispatch on-success-evt]))}))

(rf/reg-event-fx
 ::update-service
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id service-data {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :patch
       :uri (str "/api/services/" service-id)
       :params service-data
       :format (util/ajax-transit-request-format)
       :response-format (util/ajax-transit-response-format)
       :on-success [::update-service-success service-id on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-event-fx
 ::mark-service-status-as-field-visit
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :patch
       :uri (str "/api/services/" service-id "/mark-status-as-field-visit")
       :params {}
       :format (util/ajax-transit-request-format)
       :response-format (util/ajax-transit-response-format)
       :on-success [::update-service-success service-id on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-event-fx
 ::mark-service-status-as-finalization-phase
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :patch
       :uri (str "/api/services/" service-id "/mark-status-as-finalization-phase")
       :params {}
       :format (util/ajax-transit-request-format)
       :response-format (util/ajax-transit-response-format)
       :on-success [::update-service-success service-id on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-event-fx
 ::installer-submit-success
 (fn [_ [_ service-id on-success-evt _response]]
   {:fx (cond-> [[:dispatch [::fetch-service-by-id service-id]]]
          on-success-evt
          (conj [:dispatch on-success-evt]))}))

(rf/reg-event-fx
 ::installer-submit
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :patch
       :uri (str "/api/services/" service-id "/installer-submit")
       :params {}
       :format (util/ajax-transit-request-format)
       :response-format (util/ajax-transit-response-format)
       :on-success [::installer-submit-success service-id on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-sub
 ::work-packages
 (fn [db _]
   (get db :service-work-packages [])))

(rf/reg-event-fx
 ::upsert-service-analysis-success
 (fn [_ [_ service-id on-success-evt _response]]
   {:fx (cond-> [[:dispatch [::fetch-service-by-id service-id]]]
          on-success-evt
          (conj [:dispatch on-success-evt]))}))

(rf/reg-event-fx
 ::upsert-service-analysis
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id observation-id analysis {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :put
       :uri (str "/api/services/" service-id "/analyses")
       :params (assoc analysis :observation-id observation-id)
       :format (util/ajax-transit-request-format)
       :response-format (util/ajax-transit-response-format)
       :on-success [::upsert-service-analysis-success service-id on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-event-fx
 ::save-service-conclusions-success
 (fn [_ [_ _service-id on-success-evt _response]]
   {:fx (cond-> []
          on-success-evt
          (conj [:dispatch on-success-evt]))}))

(rf/reg-event-fx
 ::save-service-conclusions
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [session]} [_ service-id conclusions {:keys [on-success-evt on-failure-evt]}]]
   (when session
     {:http-xhrio
      {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
       :method :put
       :uri (str "/api/services/" service-id "/conclusions")
       :params conclusions
       :format (util/ajax-transit-request-format)
       :response-format (util/ajax-transit-response-format)
       :on-success [::save-service-conclusions-success service-id on-success-evt]
       :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))
